import * as React from 'react';
import { clsx } from 'clsx';
import { useDeviceType } from '../../../responsive';
import { Checkbox } from '../Checkbox';
import { useCheckboxGroupOptions } from '../../internal';
import { generateDataTestId } from '../../../internal/utils';
import { getStyles } from './styles';
import { jsx as _jsx } from "react/jsx-runtime";
function CheckboxGroupComponent(props) {
  var value = props.value,
    defaultValue = props.defaultValue,
    disabled = props.disabled,
    invalid = props.invalid,
    horizontal = props.horizontal,
    name = props.name,
    role = props.role,
    dataTestId = props.dataTestId;
  var deviceType = useDeviceType();
  var styles = getStyles(deviceType);
  var options = useCheckboxGroupOptions(props);
  return /*#__PURE__*/_jsx("div", {
    className: clsx(styles['checkbox-group'], horizontal ? styles['horizontal-group'] : styles['vertical-group']),
    role: role,
    "data-testid": dataTestId,
    children: options.map(function (option) {
      var optionValue = option.value;
      var key = String(optionValue);
      return /*#__PURE__*/_jsx(Checkbox, {
        name: name,
        value: key,
        checked: value && value.includes(optionValue),
        defaultChecked: (defaultValue || []).includes(optionValue) || undefined,
        disabled: disabled,
        invalid: invalid,
        label: option.label,
        onChange: option.onChange,
        role: role === 'listbox' ? 'option' : undefined,
        dataTestId: generateDataTestId(dataTestId, [key])
      }, key);
    })
  });
}

/**
 * Компонент для работы с Checkbox как с группой
 *
 * @export
 * @param {ICheckboxGroupProps} props
 * @returns
 */
export var CheckboxGroup = /*#__PURE__*/React.memo(CheckboxGroupComponent);